<template>
  <div
    :class="[
      'product-identifier-fi',
      `product-identifier-fi--${shopType}`,
      showVariantImage ? `product-identifier-fi--with-image` : '',
    ]"
    @click.stop
  >
    <div
      v-if="showVariantImage"
      class="product-identifier-fi__product-image"
    >
      <a
        class="product-identifier-fi__product-image__link"
        :href="getSlugLink(item.catalogProductData)"
        :title="item.catalogProductData.ProductName"
        @link-click="onClick"
      >
        <cloud-image-fi
          v-if="previewImage"
          :src="previewImage"
          :alt="item.name"
          :width="isLG ? '90' : '67'"
          :height="isLG ? '90' : '67'"
          trim
          params="func=fit&bg_colour=FFF"
          class="product-identifier-fi__product-image__image"
        />
      </a>
    </div>

    <div class="product-identifier-fi__data">
      <price-savings-in-percent-fi
        class="product-identifier-fi__price-savings"
        :best-price="bestPrice"
        theme="product-list-view"
      />

      <link-fi
        ref="productName"
        class="product-identifier-fi__title"
        primary
        :theme="hasLongTitle ? 'product-list-view' : ''"
        :href="getSlugLink(item.catalogProductData)"
        :title="item.catalogProductData.ProductName"
        :size="16"
        @link-click="onClick"
      >
        <span ref="productNameFull">
          {{ item.catalogProductData.ProductName }}
        </span>
      </link-fi>

      <div
        v-if="item.catalogProductData.ProductId"
        class="product-identifier-fi__article-number"
        data-test="article-number"
      >
        {{ $dict.get('product-List.Table.Article-Number') }} {{ item.catalogProductData.ProductId }}
      </div>
    </div>
  </div>
</template>

<script>
import { CloudImageFi, LinkFi, PriceSavingsInPercentFi } from 'atoms';
import { throttle } from 'throttle-debounce';
import { mapGetters } from 'vuex';

import breakpointMixin from '@/mixins/breakpointMixin.vue';
import eventHubMixin from '@/mixins/eventHubMixin.vue';
import slugLinkMixin from '@/mixins/slugLinkMixin.vue';

export default {
  name: 'ProductIdentifierFi',
  components: {
    CloudImageFi,
    LinkFi,
    PriceSavingsInPercentFi,
  },
  mixins: [breakpointMixin, eventHubMixin, slugLinkMixin],
  props: {
    item: {
      type: Object,
      default: null,
    },
    bestPrice: {
      type: Object,
      default: () => ({}),
    },
    clickSource: {
      type: String,
      default: null,
    },
    showVariantImage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasLongTitle: false,
    };
  },
  computed: {
    ...mapGetters({
      shopType: 'productList/getShopType',
      windowDimensions: 'layout/getWindowDimensions',
    }),
    previewImage() {
      return this.item.catalogProductData?.packagingImage || this.item.ImageURL;
    },
  },
  watch: {
    windowDimensions: {
      deep: true,
      handler() {
        this.throttledUpdateProductLink();
      },
    },
  },
  mounted() {
    if (IS_SSR) {
      return;
    }
    this.updateProductLink();
    this.throttledUpdateProductLink = throttle(200, this.updateProductLink);
  },
  methods: {
    onClick(event, href) {
      if (!this.clickSource) {
        return;
      }
      const productBreadcrumb = this.$store.getters['navigation/productBreadcrumb'];
      const productString = productBreadcrumb.map((item) => item.title).join('/');
      this.sendClickToEventHub(
        {
          clickSource: this.clickSource,
          pageTitle: this.item.catalogProductData.ProductName,
          productId: this.item.catalogProductData.ProductId,
          productTitle: this.item.catalogProductData.ProductName,
          query: `[${this.clickSource}]:/${productString}/${this.item.catalogProductData.ProductName}`,
        },
        event,
        href,
      );
    },
    updateProductLink() {
      if (
        IS_SSR ||
        !this.$refs.productName ||
        !this.$refs.productName.$el ||
        !this.$refs.productNameFull
      ) {
        return;
      }

      this.hasLongTitle =
        this.$refs.productNameFull.offsetHeight > this.$refs.productName.$el.offsetHeight || false;
    },
  },
};
</script>

<style scoped src="./product-identifier-fi" />
